import { REQUEST_STATUS_COMPLETED } from '../../../../../share/util/api/polling';
import session from '../../../../../share/session';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import WS45Dialog from '../Requirement045Dialog';
import requirement045Utils from './Requirement045Utils';

/** メッセージ内の置き換え文字列定義 */
const DID = '$DID$';

/** ドライブサイクルデータ取得 ID一覧 */
const DRIVE_CYCLE_DATA_TARGET_IDS = ["42", "05", "0F", "5C", "2F"]; // "68"については表示しない

/**
 * [wsp] Read ドライブサイクルデータ取得
 * @param {instance} self 呼び出し元this
 */
export async function readDriveCycleData(self) {
  try {
    self.isLoading = true;
    //バックエンドAPI POST,GET
    const token = session.getToken();
    const requestBody = {
      id_token: token.id_token,
      type: 'read',
      obd_data_id: self.obdDataId,
      system_no: self.systemNo
    };
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      requestBody,
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(true); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );
    // 正常コールバック
    if (response && response.data.status === REQUEST_STATUS_COMPLETED) {
      // 正常終了 : ドライブサイクルデータ取得画面を表示
      self.driveCycleDataResult = await self.makeDriveCycleDataDisplayInfo(response);
      self.dialog.phase = WS45Dialog.PHASE.DRIVE_CYCLE_DATA_ACQUISITION;
    } else {
      throw new Error('Unexpected error occurred');
    }
  } catch (error) {
    await requirement045Utils.exceptionHandler(requirement045Utils.METHODS.READ_DRIVE_CYCLE_DATA, error, self);
  } finally {
    requirement045Utils.terminationHandler(self);
  }
}


/**
 * ドライブサイクルデータ取得結果表示内容を整形
 * @param {instance} self 呼び出し元this
 * @returns {string} 画面表示文言
 */
export function makeDriveCycleDataDisplayInfo(self, response) {
  function getDriveCycleConfig(workSupportId) {
    switch (workSupportId) {
      case 4501:
        return { idKey: "pid", prefix: "45", sliceIndex: 2 };
      case 12501:
        return { idKey: "did", prefix: "125", sliceIndex: 4 };
      default:
        throw new Error('Unexpected error occurred');
    }
  }
  const { idKey, prefix, sliceIndex } = getDriveCycleConfig(self.workSupportId);
  let displayInfo = self.$t(`individual.label_drive_cycle_data_acquisition_ws${prefix}`);
  const readoutData = response.data.user_data.readout_data;
  DRIVE_CYCLE_DATA_TARGET_IDS.forEach((id) => {
    const target = readoutData.find(item => item[idKey].slice(0, sliceIndex).slice(-2) === id); // idについて後方一致
    if (target.is_supported) { // 結果に対象idのデータが含まれている場合
      displayInfo = displayInfo.replace(DID, (target.data_record).toFixed(target.digits_after_decimal));
    } else {
      displayInfo = displayInfo.replace(DID, "-");
    }
  });
  return displayInfo;
}

export default {
  readDriveCycleData,
  makeDriveCycleDataDisplayInfo
};